import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { RegionProvider } from "@/context/RegionContext";
import { Toaster } from "@/components/ui/sonner";
import { initTracking } from "@/lib/analytics";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import OracleWidget from "@/components/OracleWidget";
import FeedbackWidget from "@/components/FeedbackWidget";
import Home from "@/pages/Home";
import Videos from "@/pages/Videos";
import Library from "@/pages/Library";
import Classes from "@/pages/Classes";
import Store from "@/pages/Store";
import Network from "@/pages/Network";
import Forum from "@/pages/Forum";
import ForumTopic from "@/pages/ForumTopic";
import Audiobooks from "@/pages/Audiobooks";
import AudiobookDetail from "@/pages/AudiobookDetail";
import Healing from "@/pages/Healing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Join from "@/pages/Join";
import Archive from "@/pages/Archive";
import Admin from "@/pages/Admin";
import CircleTender from "@/pages/CircleTender";
import PaymentSuccess from "@/pages/PaymentSuccess";

function App() {
  useEffect(() => { initTracking(); }, []);
  return (
    <div className="App">
      <AuthProvider>
        <RegionProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/library" element={<Library />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/store" element={<Store />} />
            <Route path="/network" element={<Network />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/forum/:id" element={<ForumTopic />} />
            <Route path="/audiobooks" element={<Audiobooks />} />
            <Route path="/audiobooks/:id" element={<AudiobookDetail />} />
            <Route path="/healing" element={<Healing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/join" element={<Join />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/circle-tender" element={<CircleTender />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
          </Routes>
          <Footer />
          <OracleWidget />
          <FeedbackWidget />
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
        </RegionProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
